module.exports = __webpack_public_path__ + "static/media/2.2a45867d.png";